import { render } from "./settingsPage.vue?vue&type=template&id=b6924dec"
import script from "./settingsPage.vue?vue&type=script&lang=js"
export * from "./settingsPage.vue?vue&type=script&lang=js"

import "./settingsPage.vue?vue&type=style&index=0&id=b6924dec&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1b9778f7109bb3d60df46d4c8243c5fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__